export default "__VITE_ASSET__H3Sa3qqZ__"